import * as actionTypes from "../actions/actionTypes";

const initialState = {
  signUpForm: null,
  signUpModalStatus: false,
  signUpModalRequestedForm: "signin"
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.STORE_SIGNUP_INFO:
      return {
        ...state,
        ...{ signUpForm: action.signUpData }
      };
    case actionTypes.STORE_SIGNUP_STATUS:
      return {
        ...state,
        ...{ signUpModalStatus: action.signUpModalStatus, signUpModalRequestedForm: action.signUpModalRequestedForm }
      };
    default:
      return state;
  }
}
